import { useEffect, useState } from "react";

export default function Masthead() {
  const [date, setDate] = useState("");
  useEffect(() => {
    const d = new Date();
    const months = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
    setDate(`${String(d.getDate()).padStart(2, "0")} ${months[d.getMonth()]} ${d.getFullYear()}`);
  }, []);

  return (
    <header
      data-testid="site-masthead"
      className="sticky top-0 z-50 bg-bone/85 backdrop-blur-md border-b border-rule"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-12 py-4 md:py-5 flex md:grid md:grid-cols-12 items-center justify-between gap-3">
        <div className="hidden md:block md:col-span-3 overline text-ink/60" data-testid="masthead-issue">
          Edição N.º 001 / {date}
        </div>
        <a href="/" className="md:col-span-6 flex md:justify-center min-w-0" data-testid="masthead-logo">
          <div className="flex items-end gap-1 whitespace-nowrap">
            <span className="font-serif italic text-lg md:text-3xl tracking-tight text-ink leading-none">Sua Piscina</span>
            <span className="overline text-[9px] md:text-[10px] text-ink/50 mb-px">PT</span>
          </div>
        </a>
        <nav className="md:col-span-3 flex justify-end items-center gap-4 md:gap-6 text-xs tracking-[0.18em] uppercase flex-shrink-0">
          <a href="#processo" className="hidden lg:inline editorial-link text-ink/70 hover:text-ink" data-testid="nav-processo">Processo</a>
          <a href="#dossier" className="hidden lg:inline editorial-link text-ink/70 hover:text-ink" data-testid="nav-dossier">Dossier</a>
          <a href="#pedido" className="btn-primary !py-2 !px-3 md:!px-4 whitespace-nowrap" data-testid="nav-pedir-simulacao">
            <span className="text-[10px] md:hidden">Simular</span>
            <span className="hidden md:inline text-[11px]">Pedir simulação</span>
          </a>
        </nav>
      </div>
    </header>
  );
}
